













































































































































































































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import centrosModule from "@/store/modules/centros-module";
import { centros } from "@/shared/dtos/centros";
import { agentsAdminModule } from "@/store/modules/agents-admin-module";
import { AgentDto } from "@/shared/dtos/agents-admin";

interface AgentSelectOption {
  value: string;
  text: string;
  installation_id: string;
  tenant_id: string;
}

@Component({
  name: "CentrosManager",
})
export default class CentrosManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public dialogOpen: boolean = false;
  public isEditMode: boolean = false;

  public searchText: string = "";
  public agentFilter: string = "";
  public centroForm: centros = new centros();

  public headers: any[] = [
    { text: "Centro", value: "nombre" },
    { text: "Agente de clínica", value: "agent_id", width: "200px" },
    { text: "Teléfono", value: "telefono", width: "140px" },
    { text: "Ciudad", value: "ciudad", width: "140px" },
    { text: "Estado", value: "is_enabled", width: "140px" },
    { text: "Actualizado", value: "updated_at_utc", width: "170px" },
    { text: "Acciones", value: "actions", sortable: false, align: "center", width: "110px" },
  ];

  public mounted() {
    this.bootstrap();
  }

  public get centrosList(): centros[] {
    return centrosModule.centros;
  }

  public get filteredCentros(): centros[] {
    const search = (this.searchText || "").toLowerCase().trim();
    const agent = (this.agentFilter || "").trim();

    return this.centrosList.filter((x) => {
      const passAgent = agent === "" || x.agent_id === agent;
      if (!passAgent) return false;

      if (search === "") return true;

      const blob = [
        x.nombre,
        x.agent_id,
        x.installation_id,
        x.tenant_id,
        x.telefono,
        x.ciudad,
        x.provincia,
      ]
        .join(" ")
        .toLowerCase();

      return blob.indexOf(search) !== -1;
    });
  }

  public get clinicAgentOptions(): AgentSelectOption[] {
    return this.getUniqueAgentOptions(agentsAdminModule.agents || []);
  }

  public get agentFilterOptions(): Array<{ text: string; value: string }> {
    const options = this.clinicAgentOptions;
    if (options.length > 0) {
      return options.map((x) => ({ text: x.text, value: x.value }));
    }

    const values: Array<{ text: string; value: string }> = [];
    this.centrosList.forEach((x) => {
      if (x.agent_id && values.findIndex((i) => i.value === x.agent_id) === -1) {
        values.push({ text: x.agent_id, value: x.agent_id });
      }
    });
    return values.sort((a, b) => a.text.localeCompare(b.text));
  }

  private getUniqueAgentOptions(agents: AgentDto[]): AgentSelectOption[] {
    const map: { [key: string]: AgentSelectOption } = {};
    agents.forEach((agent) => {
      const key = agent.agent_id || "";
      if (!key) return;

      const labelParts: string[] = [];
      labelParts.push(agent.agent_id);
      if (agent.machine_name) {
        labelParts.push(agent.machine_name);
      }
      if (agent.environment_name) {
        labelParts.push(agent.environment_name);
      }

      map[key] = {
        value: key,
        text: labelParts.join(" - "),
        installation_id: agent.installation_id || "",
        tenant_id: agent.tenant_id || "",
      };
    });

    return Object.keys(map)
      .map((k) => map[k])
      .sort((a, b) => a.text.localeCompare(b.text));
  }

  public onAgentSelected(agentId: string) {
    if (!agentId) {
      this.centroForm.installation_id = "";
      this.centroForm.tenant_id = "";
      return;
    }

    const selected = this.clinicAgentOptions.find((x) => x.value === agentId);
    if (!selected) {
      this.centroForm.installation_id = "";
      this.centroForm.tenant_id = "";
      return;
    }

    this.centroForm.installation_id = selected.installation_id || "";
    this.centroForm.tenant_id = selected.tenant_id || "";
  }

  public async bootstrap() {
    this.loading = true;
    try {
      await Promise.all([
        centersafe(this.refresh(false)),
        centersafe(agentsAdminModule.getAgents({ take: 500 })),
      ]);
    } finally {
      this.loading = false;
    }
  }

  public async refresh(withLoading: boolean = true) {
    if (withLoading) {
      this.loading = true;
    }
    try {
      await centrosModule.getcentros();
    } catch (error) {
      MessageService.alert(
        "Error",
        "No se pudieron cargar los centros",
        MessageService.TypeError
      );
    } finally {
      if (withLoading) {
        this.loading = false;
      }
    }
  }

  public openCreate() {
    this.isEditMode = false;
    this.centroForm = new centros();
    this.centroForm.is_enabled = true;
    this.centroForm.is_deleted = false;
    this.dialogOpen = true;
  }

  public openEdit(item: centros) {
    this.isEditMode = true;
    this.centroForm = new centros(item);
    this.dialogOpen = true;
  }

  public async save() {
    if (!this.centroForm.nombre || !this.centroForm.agent_id) {
      MessageService.alert(
        "Validación",
        "Nombre y Agent ID son obligatorios",
        MessageService.TypeWarning
      );
      return;
    }

    this.saving = true;
    try {
      if (this.isEditMode) {
        await centrosModule.modificarcentro(this.centroForm);
      } else {
        await centrosModule.guardarcentro(this.centroForm);
      }

      MessageService.toast("Centro guardado correctamente");
      this.dialogOpen = false;
      await this.refresh();
    } catch (error) {
      MessageService.alert(
        "Error",
        "No se pudo guardar el centro",
        MessageService.TypeError
      );
    } finally {
      this.saving = false;
    }
  }

  public remove(item: centros) {
    MessageService.confirm(
      "¿Quieres eliminar este centro?",
      "Confirmación",
      async (res: boolean) => {
        if (!res) return;
        try {
          await centrosModule.eliminarcentro(item);
          MessageService.toast("Centro eliminado correctamente");
          await this.refresh();
        } catch (error) {
          MessageService.alert(
            "Error",
            "No se pudo eliminar el centro",
            MessageService.TypeError
          );
        }
      }
    );
  }

  public formatDate(value: Date | string | null): string {
    if (!value) return "-";
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return "-";
    return d.toLocaleString();
  }
}

async function centersafe(promise: Promise<any>) {
  try {
    await promise;
  } catch (e) {
    // No-op: cada flujo ya notifica su error de forma específica.
  }
}
